import { iPermissionKey } from './permissions';

export enum iPeriod {
    month = 'month',
    year = 'year',
}

export interface iPlan {
    id?: number;
    name: string;
    description: string;
    price: number;
    permissions: iPermissionKey[];
    created_at?: string;
    updated_at?: string;
    deactivated_at?: string;
    period: iPeriod;
    img?: string;
}
